var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelopeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope icon",
    d: "M20.9785 0H2.02148C0.90823 0 0 0.880338 0 1.96154V15.0385C0 16.116 0.904188 17 2.02148 17H20.9785C22.089 17 23 16.1226 23 15.0385V1.96154C23 0.884 22.0958 0 20.9785 0ZM20.6994 1.30769L11.5429 10.1927L2.30714 1.30769H20.6994ZM1.34766 14.7677V2.22608L7.83792 8.46988L1.34766 14.7677ZM2.30058 15.6923L8.79494 9.39054L11.0705 11.5797C11.334 11.8331 11.7591 11.8323 12.0214 11.5777L14.2402 9.42467L20.6994 15.6923H2.30058ZM21.6523 14.7676L15.1932 8.5L21.6523 2.23232V14.7676Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeWhite);
export default __webpack_public_path__ + "static/media/envelope-white.9b9114f90ffd4427942e6b2f68d6296e.svg";
export { ForwardRef as ReactComponent };